import api from "@/lib/api";

// Bridge to the "PostPintar Helper" Chrome extension (see /app/extension).
export const helperVersion = () => document.documentElement.getAttribute("data-pp-helper");
export const hasHelper = () => !!helperVersion();
export const HELPER_ZIP = "/postpintar-helper.zip";
export const HELPER_LATEST_VERSION = "1.5.3";
// Lets the extension remember this PostPintar address so it can check for new versions by itself.
export const announceToHelper = () => { if (hasHelper()) window.postMessage({ source: "pp-app", type: "HELLO" }, window.location.origin); };
export const isHelperOutdated = () => hasHelper() && !versionAtLeast(helperVersion(), HELPER_LATEST_VERSION);

export const HELPER_CHANGELOG = [
  { v: "1.5.3", date: "2026-10-07", items: ["Tiada lagi popup 'Leave site? / Tinggalkan laman?' bila post gagal - Mod Latar terus ke group seterusnya secara automatik (tab Facebook biasa tidak terjejas)"] },
  { v: "1.5.2", date: "2026-10-06", items: ["Waktu Rehat Automatik: Mod Latar berhenti post pada waktu ditetapkan (cth 12:00 malam - 7:00 pagi) dan sambung sendiri selepas itu", "Kemajuan langsung di Papan Pemuka: group yang sedang dipost, bar kemajuan & anggaran masa siap"] },
  { v: "1.5.1", date: "2026-10-06", items: ["Had harian Mod Latar kini ikut tarikh tempatan (reset tengah malam waktu Malaysia, bukan 8 pagi)", "Status Mod Latar langsung di Papan Pemuka"] },
  { v: "1.5.0", date: "2026-10-06", items: ["Mod Latar tidak lagi mati sendiri - hanya berhenti bila anda tekan tutup", "Ralat rangkaian/server: Helper cuba semula setiap minit (tiada auto-off)", "Token Mod Latar diperbaharui automatik setiap hari & setiap kali PostPintar dibuka", "Kunci 'sedang post' yang tersangkut dilepaskan automatik selepas 4 minit", "Chrome kekal berjalan di latar (kebenaran background) supaya Mod Latar tidak terhenti bila tetingkap ditutup"] },
  { v: "1.4.1", date: "2026-10-05", items: ["Sokongan domain sendiri postpintar.destinyjunior.my (dan *.destinyjunior.my)"] },
  { v: "1.4.0", date: "2026-10-04", items: ["Semak versi automatik: Helper sendiri beritahu dalam Chrome (notifikasi + lencana NEW) bila versi baharu tersedia", "Klik notifikasi atau ikon Helper untuk terus ke halaman muat turun di Tetapan", "Post oleh Mod Latar direkod dalam Sejarah Helper"] },
  { v: "1.3.1", date: "2026-10-04", items: ["Sokongan domain *.vercel.app (PostPintar yang dihos di Vercel)"] },
  { v: "1.3.0", date: "2026-10-04", items: ["Mod Latar Chrome: post automatik di latar walaupun tab PostPintar ditutup", "Had post harian & jarak antara group untuk mod latar", "Notifikasi Chrome bila sesi tamat"] },
  { v: "1.2.0", date: "2026-10-04", items: ["Kesan kegagalan (bukan ahli, menunggu kelulusan join, group tiada) & tanda gagal dengan sebab", "Langkau automatik selepas 10 saat & watchdog 90 saat", "Laporan sesi dihantar ke notifikasi / emel"] },
  { v: "1.1.1", date: "2026-10-04", items: ["Pilihan Auto tekan Siaran (klik seperti manusia selepas 3-7 saat)", "Pilihan jarak: 1-3 minit rawak / 5 minit / 10 minit", "Tutup popup untuk henti mod auto serta-merta"] },
  { v: "1.0.0", date: "2026-10-04", items: ["Satu popup group yang diguna semula", "Isi teks & gambar automatik dalam \"Cipta siaran\"", "Kesan bila anda tekan Siaran -> tanda selesai, auto ke group seterusnya"] },
];

const AUTO_KEY = "pp_auto_next";
export const getAutoNext = () => localStorage.getItem(AUTO_KEY) !== "0";
export const setAutoNext = (on) => localStorage.setItem(AUTO_KEY, on ? "1" : "0");

const AUTO_POST_KEY = "pp_auto_post";
export const getAutoPost = () => localStorage.getItem(AUTO_POST_KEY) === "1";
export const setAutoPost = (on) => localStorage.setItem(AUTO_POST_KEY, on ? "1" : "0");

export const AUTO_POST_MIN_VERSION = "1.1.0";
export function versionAtLeast(v, min) {
  const a = String(v || "0").split(".").map(Number);
  const b = String(min).split(".").map(Number);
  for (let i = 0; i < 3; i++) {
    if ((a[i] || 0) !== (b[i] || 0)) return (a[i] || 0) > (b[i] || 0);
  }
  return true;
}
// Wait between groups (seconds). "rand" = random 1-3 minit, "5" = 5 minit, "10" = 10 minit
const GAP_KEY = "pp_gap";
export const GAP_OPTIONS = [
  { v: "rand", l: "1-3 minit (rawak)" },
  { v: "5", l: "5 minit" },
  { v: "10", l: "10 minit" },
];
export const getGapPref = () => (GAP_OPTIONS.some((o) => o.v === localStorage.getItem(GAP_KEY)) ? localStorage.getItem(GAP_KEY) : "rand");
export const setGapPref = (v) => localStorage.setItem(GAP_KEY, v);
export const gapSeconds = (pref = getGapPref()) => (pref === "rand" ? 60 + Math.floor(Math.random() * 121) : Number(pref) * 60);
export const randomGap = () => gapSeconds("rand");

async function imageDataUrl(id) {
  const res = await api.get(`/images/${id}`, { responseType: "blob" });
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result);
    fr.onerror = reject;
    fr.readAsDataURL(res.data);
  });
}

function bounds() {
  const sw = window.screen.availWidth || 1280;
  const sh = window.screen.availHeight || 800;
  const width = Math.max(520, Math.min(900, Math.round(sw * 0.5)));
  return { width, height: sh, left: (window.screen.availLeft || 0) + sw - width, top: window.screen.availTop || 0 };
}

// Ask the extension to open/reuse the group popup and pre-fill "Cipta siaran".
export async function openWithHelper(item, text, { autoPost = false } = {}) {
  const image = item.image_id ? await imageDataUrl(item.image_id).catch(() => null) : null;
  window.postMessage(
    { source: "pp-app", type: "OPEN", job: { jobId: item.tid, url: item.group_url, text, image, imageName: "postpintar", bounds: bounds(), autoPost } },
    window.location.origin,
  );
}

export function onHelperEvent(cb) {
  const handler = (e) => {
    if (e.source !== window || !e.data || e.data.source !== "pp-helper") return;
    cb(e.data);
  };
  window.addEventListener("message", handler);
  return () => window.removeEventListener("message", handler);
}

export const AUTO_BG_MIN_VERSION = "1.3.0";
export const AUTO_QUIET_MIN_VERSION = "1.5.2";

const toMin = (s) => { const [h, m] = String(s).split(":").map(Number); return h * 60 + m; };
// Same rule as the extension: window may wrap past midnight.
export function inQuiet(q, d = new Date()) {
  if (!q?.on || !q.start || !q.end || q.start === q.end) return false;
  const m = d.getHours() * 60 + d.getMinutes(), s = toMin(q.start), e = toMin(q.end);
  return s < e ? m >= s && m < e : m >= s || m < e;
}
function quietEndAfter(q, d) {
  const end = new Date(d);
  end.setHours(...String(q.end).split(":").map(Number), 0, 0);
  if (end <= d) end.setDate(end.getDate() + 1);
  return end;
}
const GAP_AVG = { rand: 120, 5: 300, 10: 600 };

// Simulate the remaining groups (gap + post time, skipping quiet hours) -> finish Date.
export function estimateFinish(auto, remaining, now = Date.now()) {
  if (!auto?.enabled || remaining <= 0) return null;
  const post = (auto.avgPostMs || 60000);
  const gap = (GAP_AVG[auto.gap] || 120) * 1000;
  let t = new Date(now);
  let left = remaining;
  if (auto.running) { t = new Date(now + Math.max(5000, post - (now - (auto.runningSince || now)))); left -= 1; if (left > 0) t = new Date(+t + gap); }
  else if (auto.nextRunAt > now) t = new Date(auto.nextRunAt);
  for (let i = 0; i < left; i++) {
    if (inQuiet(auto.quiet, t)) t = quietEndAfter(auto.quiet, t);
    t = new Date(+t + post + (i < left - 1 ? gap : 0));
  }
  return t;
}

// Ask the extension for current autopilot state (resolves null if no helper).
export function getAutopilot() {
  return new Promise((resolve) => {
    if (!hasHelper()) return resolve(null);
    const off = onHelperEvent((d) => { if (d.type === "AUTO") { off(); resolve(d.auto || null); } });
    window.postMessage({ source: "pp-app", type: "GET_AUTO" }, window.location.origin);
    setTimeout(() => { off(); resolve(null); }, 2000);
  });
}

// Enable/disable background autopilot. On enable we fetch a 30-day Bearer token.
export async function setAutopilot(config) {
  if (!hasHelper()) throw new Error("Helper tidak dipasang");
  const cfg = { ...config };
  if (cfg.enabled) {
    const { data } = await api.post("/auth/automation-token");
    cfg.token = data.token;
    cfg.apiBase = window.location.origin;
  }
  return new Promise((resolve) => {
    const off = onHelperEvent((d) => { if (d.type === "AUTO") { off(); resolve(d.auto || null); } });
    window.postMessage({ source: "pp-app", type: "SET_AUTO", config: cfg }, window.location.origin);
    setTimeout(() => { off(); resolve(null); }, 3000);
  });
}

// When the app is opened, silently hand a fresh token to Mod Latar (keeps it running, never toggles it).
export async function refreshAutopilotToken() {
  if (!versionAtLeast(helperVersion(), AUTO_BG_MIN_VERSION)) return;
  const a = await getAutopilot();
  if (!a || !a.enabled) return;
  const { data } = await api.post("/auth/automation-token").catch(() => ({ data: null }));
  if (data && data.token) window.postMessage({ source: "pp-app", type: "SET_AUTO", config: { token: data.token, apiBase: window.location.origin } }, window.location.origin);
}
